
<template>
  <div class="page" ref="pageRef">
    <div class="page_top_bg">
      <img :src="Info.pic" />
    </div>
    <div class="page_wrap">
      <div class="info_title">{{ Info.name }}</div>
      <div class="time">{{ Info.time }}</div>
      <div class="content" v-html="Info.content"></div>
      <div class="back_btn" @click="handleRouter">返回列表</div>
    </div>
  </div>
</template>
  
  <script  lang="ts">
import axios from "axios";
import {
  defineComponent,
  getCurrentInstance,
  h,
  onMounted,
  reactive,
  ref,
  toRefs,
  watchEffect,
} from "vue";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance() as any;

    const state = reactive({
      Info: {} as any,
    });
    onMounted(() => {});
    const router = useRouter();
    const route = useRoute();
    const pageRef = ref();
    const scrollToTop = () => {
      if (pageRef.value) {
        pageRef.value.scrollIntoView({ behavior: "smooth" });
      }
    };
    watchEffect(() => {
      if (route.query.id) {
        setTimeout(() => {
          scrollToTop();
          getInfo(route.query.id);
        }, 0);
      }
    });

    const getInfo = async (id: any) => {
      axios.get(`/api/t_show_content/${id}`).then((res: any) => {
        if (res.data.code == 200) {
          state.Info = res.data.data;
        }
      });
    };
    const handleRouter = () => {
      router.go(-1);
    };
    return {
      handleRouter,
      getInfo,
      pageRef,
      ...toRefs(state),
    };
  },
});
</script>
  <style lang="scss">
.page {
  .page_top_bg {
    width: 100%;
    height: 426px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 426px;
      object-fit: cover;
    }
  }
  .page_wrap {
    width: 1200px;
    margin: -300px auto 32px;
    position: relative;
    z-index: 10;
    border-radius: 16px;
    background: #ffffff;
    min-height: 800px;
    padding: 40px 48px 100px;
    .info_title {
      font-weight: bold;
      font-size: 36px;
      color: #000000;
      line-height: 42px;
      letter-spacing: 3px;
    }
    .time {
      padding: 25px 0px 32px;
      font-size: 12px;
      color: #999999;
    }
    .content {
      width: 1200px;
      img {
        max-width: 100% !important;
        height: auto !important;
        display: block;
      }
    }
    .back_btn {
      width: 160px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #377dca;
      font-weight: 600;
      font-size: 14px;
      color: #377dca;
      line-height: 40px;
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 25px;
      cursor: pointer;
    }
  }
}
</style>
    